export const CANONICAL_PASSWORD_MIN_LENGTH = 8;

export const CANONICAL_SPECIAL_CHARACTERS = '#?!@$%^&*-';

export const CANONICAL_SPECIAL_REGEX = /[#?!@$%^&*-]/;

const FAILURE_I18N = {
  min: 'validation:password_policy_min',
  uppercase: 'validation:password_policy_uppercase',
  lowercase: 'validation:password_policy_lowercase',
  digit: 'validation:password_policy_digit',
  special: 'validation:password_policy_special',
  mismatch: 'validation:password_policy_mismatch',
};

/**
 * UX-only checks. Backend remains the authority.
 * Never log or persist the password.
 *
 * @param {string} password
 * @param {string} [confirmation]
 * @returns {string[]}
 */
export function canonicalPasswordFailures(password, confirmation) {
  const value = typeof password === 'string' ? password : '';
  const failures = [];

  if (value.length < CANONICAL_PASSWORD_MIN_LENGTH) {
    failures.push('min');
  }
  if (!/[A-Z]/.test(value)) {
    failures.push('uppercase');
  }
  if (!/[a-z]/.test(value)) {
    failures.push('lowercase');
  }
  if (!/[0-9]/.test(value)) {
    failures.push('digit');
  }
  if (!CANONICAL_SPECIAL_REGEX.test(value)) {
    failures.push('special');
  }
  if (confirmation !== undefined && value !== confirmation) {
    failures.push('mismatch');
  }

  return failures;
}

export function isCanonicalPassword(password, confirmation) {
  return canonicalPasswordFailures(password, confirmation).length === 0;
}

export function canonicalPasswordFailureI18nKeys(failures) {
  return failures.map((code) => FAILURE_I18N[code]).filter(Boolean);
}
